import MovieCard from '@/components/base/MovieCard';
import { newMovies } from '@/mocks/movies';

export default function LatestSection() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center gap-3 mb-6 md:mb-8">
        <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
          <i className="ri-flashlight-fill text-background-50 text-sm"></i>
        </div>
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
          最新上线
        </h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
        {newMovies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}